module.exports = __webpack_public_path__ + "media/images/misc/button-overlay-39653139691211c1b4459d3ff1b58776d0a94b1531bf9762fe5ba5481fc1f277.png";